module.exports = __webpack_public_path__ + "static/WEDDING E&M-100-fca0915310c14c69f6347d800a859ed5.jpg";